import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { DocumentNode } from '@worldathletics/types';

type NodeSliceProps = { data: DocumentNode; isLoaded: boolean };

const initialState: NodeSliceProps = {
  data: {
    id: '',
    bookId: '',
    version: 0,
    language: 'EN',
    state: 'DRAFT',
    contributors: [],
    createdAt: '',
    updatedAt: '',
    blocks: [],
    numberingStyle: 'numeric',
  },
  isLoaded: false,
};

export const documentBookNodeSlice = createSlice({
  name: 'documentBookNode',
  initialState,
  reducers: {
    setBookNode: (state, action: PayloadAction<DocumentNode>) => {
      state.data = action.payload;
    },
    clearBookNode: () => initialState,
    setIsLoadedNode: (state, action: PayloadAction<boolean>) => {
      state.isLoaded = action.payload;
    },
  },
});

export const { setBookNode, clearBookNode, setIsLoadedNode } =
  documentBookNodeSlice.actions;

export default documentBookNodeSlice.reducer;
